// extracted by mini-css-extract-plugin
export default {"field":"ZybQ0Fd0rdXBI4gmlGHN","hex":"LRhz6CNUhWwmfUbprOhQ","ripple":"Q6XSzxzn0DWOigUUcDUj","delay1":"K0tBdt8SjZVhelQGgzW1","delay2":"WThGbi2uvoxdIOfPqUeg"};